import { CustomerVariables } from "./variable_interfaces";

const TEST_ENV_BASEPATH = 'https://kirjaudu-dev.lumme-energia.fi';
const PROD_ENV_BASEPATH = 'https://kirjaudu.lumme-energia.fi';
const LOCAL_AUTH = 'http://localhost:8080/auth';
const LOCAL_LOGOUT_URL = 'http://localhost:3001';

export const lummeVariables: CustomerVariables = {
    realmName: 'Lumme',
    USER_SETTINGS_LINK: `${process.env.REACT_APP_ENV !== 'production' ? `${process.env.REACT_APP_ENV === 'test' ? TEST_ENV_BASEPATH + '/auth' : LOCAL_AUTH}` : PROD_ENV_BASEPATH + '/auth'}/realms/Lumme/account/#/personal-info`,
    KEYCLOAK_URL: `${process.env.REACT_APP_ENV !== 'production' ? `${process.env.REACT_APP_ENV === 'test' ? TEST_ENV_BASEPATH + '/auth' : LOCAL_AUTH}` : PROD_ENV_BASEPATH + '/auth'}/`,
    KEYCLOAK_BASE_PATH: `${process.env.REACT_APP_ENV !== 'production' ? `${process.env.REACT_APP_ENV === 'test' ? TEST_ENV_BASEPATH + '/auth' : '/auth'}` : PROD_ENV_BASEPATH + '/auth'}`,
    AUTHORIZATION_MAX_PERIOD_OF_VALIDITY_IN_YEARS: 2,
    LOGOUT_URL: `${process.env.REACT_APP_ENV !== 'production' ? `${process.env.REACT_APP_ENV === 'test' ? TEST_ENV_BASEPATH : LOCAL_LOGOUT_URL}` : PROD_ENV_BASEPATH}`,
    KEYCLOAK_CLIENT_ID: 'representatives-end-user-ui',
    localizationLanguages: [
        {
            language: 'Finnish',
            languageAbbreviation: 'fi'
        }
    ],
    headerMenuLinks: [
        {
            buttonTitle: 'OmaLumme',
            buttonLink: process.env.REACT_APP_ENV === 'production' ? 'https://oma.lumme-energia.fi/' : 'https://oma-dev.lumme-energia.fi/'
        },
        {
            buttonTitle: 'Lumme-tiimi',
            buttonLink: 'https://tiimi.lumme-energia.fi/'
        },
        {
            buttonTitle: 'OmaLumme-mobiilisovellus',
            buttonLink: 'serena-lumme://registered',
            hideInDesktop: true
        },
        {
            buttonTitle: 'Mobiilisovellus App Storessa',
            buttonLink: 'https://apps.apple.com/us/app/omalumme/id6444796800',
            hideInDesktop: true
        },
        {
            buttonTitle: 'Mobiilisovellus Google Playssa',
            buttonLink: 'https://play.google.com/store/apps/details?id=fi.lummeenergia.omalumme',
            hideInDesktop: true
        }
    ],
    showCustomerLogoOnRepresentationPages: true
}